export enum FeesDisplayMode {
  Summary = "Summary",
  Detail = "Detail",
}
